import React from 'react';

const ConsumerIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="9.99968" cy="6.66671" r="3.33333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M4.16666 16.6667C4.16666 14.5833 5.83332 13 7.83332 13H12.0833C14.1667 13 15.75 14.6667 15.75 16.6667"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ConsumerIcon;
